import { useEffect, useState } from "react";
import axios from "axios";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/faqs`)
      .then((res) => {
        if (!cancelled) setFaqs(res.data.faqs || []);
      })
      .catch(() => {
        if (!cancelled) setFaqs([]);
      })
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="text-slate-500 text-sm" data-testid="faq-loading">
        Loading frequently asked questions...
      </div>
    );
  }

  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {faqs.map((faq, idx) => (
        <AccordionItem
          key={idx}
          value={`item-${idx}`}
          className="border-slate-800"
          data-testid={`faq-item-${idx}`}
        >
          <AccordionTrigger
            className="text-left font-display font-semibold text-white hover:text-red-500 py-6 text-base md:text-lg"
            data-testid={`faq-trigger-${idx}`}
          >
            {faq.question}
          </AccordionTrigger>
          <AccordionContent
            className="text-slate-400 leading-relaxed text-base pb-6"
            data-testid={`faq-content-${idx}`}
          >
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
